import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineProps } from "vue/dist/vue";
import TitleBase from "@/components/Titles/TitleBase.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleExtraBig',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TitleBase, {
    class: "text-4xl md:text-5xl",
    text: props.text
  }, null, 8, ["text"]))
}
}

})